import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
  pagination,
} from "../../../store/administration/selectors/requirements";

const Requirements = lazy(() => import("./Requirements"));

const mapStateToProps = (state) => ({
  isLoading: loading(state),
  requirements: data(state),
  pagination: pagination(state),
});

export default connect(mapStateToProps)(Requirements);
